<template>
  <div class="demo-logout-btn" @click="logoutBtn">
    <div class="icon">
      <IconLogout2/>
    </div>
    <div class="text-md font-medium leading-6 truncate">
      {{ $t('btnLabel') }}
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import IconLogout2 from "@/components/icons/IconLogout2";

export default {
  name: "DemoLogoutBtn",
  components: {IconLogout2},
  computed: {
    ...mapState('auth', ['fp']),
  },
  methods: {
    ...mapActions('auth', ['logoutDemoAccount']),
    async logoutBtn() {
      let fingerprint = this.fp.result;
      await this.logoutDemoAccount(fingerprint);
    },
  },
  i18n: {
    messages: {
      en: {
        btnLabel: 'Exit Demo Account'
      },
      ru: {
        btnLabel: 'Выйти из Демо-аккаунта'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.demo-logout-btn {
  @apply flex items-center min-w-188px pr-6 rounded relative
  text-white cursor-pointer text-lg
  transition duration-200
  bg-yellow shadow-yellow;
  height: 36px;
  border-radius: 4px;

  .icon {
    @apply flex items-center justify-center m-2 rounded text-white;
    height: 28px;
    width: 28px;
    margin-right: 14px;
    background: #DB9435;
  }

  &:hover {
    @apply bg-yellow-hover shadow-yellowHover;
  }
}
</style>